import { render, staticRenderFns } from "./CRUDContratosSubsidioV2.vue?vue&type=template&id=5154b1de&"
import script from "./CRUDContratosSubsidioV2.vue?vue&type=script&lang=js&"
export * from "./CRUDContratosSubsidioV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports